module.exports = __webpack_public_path__ + "static/img/pic_hywz_bg@2x.2e60f3d9.png";